/**
 * HTTP and WebSocket base URLs for the FastAPI backend.
 *
 * Priority:
 * 1. NEXT_PUBLIC_BACKEND_WS_URL (e.g. wss://host/farmavoice/api) if set at build time.
 * 2. Same-origin + path from NEXT_PUBLIC_API_PATH, or NEXT_PUBLIC_BASE_PATH + /api.
 * 3. Local dev: http://localhost:8000 / ws://localhost:8000 when hostname is localhost.
 */

function wsToHttp(wsUrl: string): string {
  return wsUrl
    .replace(/^ws:\/\//i, "http://")
    .replace(/^wss:\/\//i, "https://");
}

function isBrowser(): boolean {
  return typeof window !== "undefined";
}

function isLocalhost(): boolean {
  return isBrowser() && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
}

/** Path prefix for the API on the same host (e.g. /farmavoice/api when UI is at / but API is under /farmavoice). */
function sameOriginApiPath(): string {
  const explicit = process.env.NEXT_PUBLIC_API_PATH?.trim();
  if (explicit) {
    return explicit.startsWith("/") ? explicit : `/${explicit}`;
  }
  const basePath = process.env.NEXT_PUBLIC_BASE_PATH ?? "";
  return `${basePath}/api`;
}

/** Base URL for fetch() — https?://… */
export function getBackendHttpBase(): string {
  const env = process.env.NEXT_PUBLIC_BACKEND_WS_URL?.trim();
  if (env) {
    return wsToHttp(env);
  }
  if (isBrowser() && !isLocalhost()) {
    return `${window.location.origin}${sameOriginApiPath()}`;
  }
  return "http://localhost:8000";
}

/** Base URL for WebSocket — ws:// or wss:// */
export function getBackendWsBase(): string {
  const env = process.env.NEXT_PUBLIC_BACKEND_WS_URL?.trim();
  if (env) {
    return env;
  }
  if (isBrowser() && !isLocalhost()) {
    const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
    return `${proto}//${window.location.host}${sameOriginApiPath()}`;
  }
  return "ws://localhost:8000";
}
